"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var TradeableRatesNewIcon = function TradeableRatesNewIcon(props) {
  return _react["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 30 30",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, _react["default"].createElement("title", null, "Money Transfer Icon"), _react["default"].createElement("defs", null, _react["default"].createElement("polygon", {
    points: "0.000199757497 0.999 23.9973456 0.999 23.9973456 25 0.000199757497 25"
  })), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(3.000000, 2.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(0.000000, 0.001200)"
  }, _react["default"].createElement("path", {
    d: "M23.705,1.291 C23.431,1.017 23.02,0.927 22.656,1.058 L0.658,9.06 C0.337,9.177 0.098,9.45 0.024,9.784 C-0.05,10.117 0.051,10.465 0.293,10.707 L1.293,11.707 C1.684,12.098 2.316,12.098 2.707,11.707 C3.061,11.353 3.094,10.799 2.806,10.407 L21.326,3.67 L14.597,22.183 L11.284,18.869 L18.577,7.804 C18.839,7.407 18.785,6.882 18.449,6.546 C18.114,6.21 17.588,6.157 17.191,6.419 L5.449,14.165 C5.169,14.351 5,14.664 5,15 L5,19 C5,19.553 5.448,20 6,20 L7,20 C7.552,20 8,19.553 8,19 C8,18.447 7.552,18 7,18 L7,15.538 L14.226,10.771 L9.165,18.449 C8.904,18.846 8.957,19.371 9.293,19.707 L14.293,24.707 C14.482,24.896 14.738,25 15,25 C15.072,25 15.144,24.992 15.217,24.977 C15.551,24.902 15.823,24.663 15.939,24.342 L23.937,2.34 C24.07,1.975 23.979,1.565 23.705,1.291",
    fill: "#fff"
  })), _react["default"].createElement("path", {
    d: "M3.7499,12.0012 C3.0599,12.0012 2.4999,12.5612 2.4999,13.2512 C2.4999,13.9412 3.0599,14.5012 3.7499,14.5012 C4.4399,14.5012 4.9999,13.9412 4.9999,13.2512 C4.9999,12.5612 4.4399,12.0012 3.7499,12.0012",
    fill: "#fff"
  }))));
};

var _default = TradeableRatesNewIcon;
exports["default"] = _default;